import { render } from "./nft-item-detail.vue?vue&type=template&id=bcbcbba2"
import script from "./nft-item-detail.vue?vue&type=script&lang=js"
export * from "./nft-item-detail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tatsa\\Desktop\\PROJETS\\SUFOSERVICES\\sufo-webadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__